import { DependencyList, useEffect } from 'react';

type useClickAwayListenerProps = {
  refs: React.RefObject<HTMLElement | null>[];
  onClickAway: () => void;
  deps?: DependencyList;
  ignore?: (target: Node) => boolean;
};

export const useClickAwayListener = (props: useClickAwayListenerProps) => {
  const { refs, onClickAway, deps = [], ignore } = props;

  useEffect(() => {
    function handleClick(e: MouseEvent) {
      const target = e.target as Node;

      const clickedInsideRefs = refs.some((ref) =>
        ref.current?.contains(target),
      );

      if (clickedInsideRefs) return;

      if (ignore?.(target)) return;

      onClickAway();
    }

    document.addEventListener('mousedown', handleClick);

    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, [...deps]);
};
